export default function trackSteps(step: number) {

  //submits displayed step to Google Tag Manager (GTM), which is located outside of the react app

  //steps are:
  // 1 = Afspraak
  // 2 = Winkel, datum & tijd
  // 3 = Persoonsgegevens
  // 4 = Bevestigen

  const dataLayer = (window as any).dataLayer || [];

  dataLayer.push(
      { 'event': 'ebooking_step', 'step_number': step }
    );
}